import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

export default function EmailStatementModal({ 
  show, 
  onHide, 
  defaultEmail, 
  statementData, 
  pdfBlob,
  sendStatementByEmail 
}) {
  const [recipientEmail, setRecipientEmail] = useState(defaultEmail || "");
  const [statementPassword, setStatementPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Keep recipientEmail in sync if defaultEmail changes
  useEffect(() => {
    setRecipientEmail(defaultEmail || "");
  }, [defaultEmail]);

  const handleSendEmail = () => {
    // 1) Basic validation
    if (!recipientEmail) {
      setErrorMessage("Email is required");
      return;
    }

    // 2) Close the modal immediately
    onHide();

    // 3) Build form data
    const formData = new FormData();
    formData.append("email", recipientEmail);
    formData.append("password", statementPassword);
    formData.append("statementData", JSON.stringify(statementData));
    if (pdfBlob) {
      formData.append("pdf", pdfBlob, "Statement.pdf");
    }

    // 4) Fire-and-forget
    sendStatementByEmail(formData)
      .catch((err) => {
        console.error("Failed to send statement email:", err);
        // Optionally: you could trigger a client-side toast here
      });

    // 5) reset local error state (in case user reopens)
    setErrorMessage("");
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Send Statement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorMessage && (
          <Alert variant="danger" className="mb-3">
            {errorMessage}
          </Alert>
        )}

        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Recipient Email Address</Form.Label>
            <Form.Control
              type="email"
              value={recipientEmail}
              onChange={(e) => setRecipientEmail(e.target.value)}
              placeholder="Enter recipient email"
              isInvalid={!!errorMessage && !recipientEmail}
            />
          </Form.Group>

         {/*} <Form.Group className="mb-3">
            <Form.Label>Statement Password (optional)</Form.Label>
            <Form.Control
              type="text"
              value={statementPassword}
              onChange={(e) => setStatementPassword(e.target.value)}
              placeholder="Enter password if needed"
            />
          </Form.Group> */}
          <p>The statement will be sent as a PDF attachment to the email address above. You will be notified once it has been sent.</p>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSendEmail}>
          Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
